// get events from react and send em to sfra js
document.body.addEventListener("reactEvent", e => {
    if (!e.detail || !e.detail.eventName) {
        return false;
    }
    window
        .jQuery(e.detail.target)
        .trigger(e.detail.eventName, e.detail.eventData);
});
